import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

const AmountRow = ({ amountLabel, amountValue }) => (
  <Box display="flex" justifyContent="space-between" my={1}>
    <Typography variant="body2">{amountLabel}</Typography>
    <Typography variant="body2">₹ {amountValue}</Typography>
  </Box>
);

const PaymentSplitDetails = ({ pricing }) => {

  // console.log('Response at the calculate pricing:', JSON.stringify(pricing, null, 2));


  if (!pricing) return null;

  // Compute total discount summary if present
  const totalDiscount = (Number(pricing?.discount?.value)||0)
    + (Number(pricing?.platformFee?.discount?.value)||0)
    + (Number(pricing?.convenienceFee?.discount?.value)||0);

  return (
    <Box sx={{ p: 2, border: '1px solid #ccc', borderRadius: 2 }}>

      {pricing?.ticketBreakdown &&
        Object.entries(pricing?.ticketBreakdown).map(([ticketType, details]) => (
          <AmountRow
            key={ticketType}
            amountLabel={`${details.count} × ${ticketType} Ticket @ ₹${details.price}`}
            amountValue={(details.count * details.price).toFixed(2)}
          />
        ))}




      {/* Base Amount */}
      {pricing?.baseAmount && <AmountRow amountLabel={pricing.baseAmount.key} amountValue={pricing.baseAmount.value} />}

      {/* Discount */}
      {pricing?.discount?.value > 0 && (
        <AmountRow
          amountLabel={`${pricing.discount.key} - ${pricing.discount.config?.reason}`}
          amountValue={pricing.discount.value}
        />
      )}

      {/* Tax */}
      {/* {pricing?.tax?.isIGST?.value ? (
        pricing?.tax?.igst && <AmountRow amountLabel={pricing.tax.igst.key} amountValue={pricing.tax.igst.value} />
      ) : (
        <>
          {pricing?.tax?.cgst && <AmountRow amountLabel={pricing.tax.cgst.key} amountValue={pricing.tax.cgst.value} />}
          {pricing?.tax?.sgst && <AmountRow amountLabel={pricing.tax.sgst.key} amountValue={pricing.tax.sgst.value} />}
        </>
      )} */}

      {Array.isArray(pricing?.tax) && pricing.tax.length > 0 && (
        <>
          {pricing.tax.map((taxItem, index) => (
            <AmountRow
              key={index}
              amountLabel={taxItem.key}
              amountValue={taxItem.value}
            />
          ))}
        </>
      )}


      <Divider sx={{ my: 1 }} />
      {/* Total Discount summary */}
      {totalDiscount > 0 && (
        <AmountRow amountLabel={`Total Discount`} amountValue={-Math.abs(totalDiscount)} />
      )}

      {/* Price after Tax */}
      {pricing?.priceAfterTax && (
        <AmountRow amountLabel={pricing.priceAfterTax.key} amountValue={pricing.priceAfterTax.value} />
      )}

      <Divider sx={{ my: 1 }} />

      {/* Platform Fee */}
      {pricing?.platformFee?.originalFee && (
        <AmountRow
          amountLabel={pricing.platformFee.originalFee.key}
          amountValue={pricing.platformFee.originalFee.value}
        />
      )}

      {pricing?.platformFee?.discount?.value != 0 && (
        <AmountRow
          amountLabel={`${pricing.platformFee.discount.key}${pricing.platformFee.discount?.config?.reason ? ` - ${pricing.platformFee.discount.config.reason}` : ''}`}
          amountValue={pricing.platformFee.discount.value}
        />
      )}

      {/* Platform Fee Tax */}
      {pricing?.platformFee?.tax?.isIGST?.value ? (
        pricing?.platformFee?.tax?.igst && (
          <AmountRow amountLabel={pricing.platformFee.tax.igst.key} amountValue={pricing.platformFee.tax.igst.value} />
        )
      ) : (
        <>
          {pricing?.platformFee?.tax?.cgst && (
            <AmountRow amountLabel={pricing.platformFee.tax.cgst.key} amountValue={pricing.platformFee.tax.cgst.value} />
          )}
          {pricing?.platformFee?.tax?.sgst && (
            <AmountRow amountLabel={pricing.platformFee.tax.sgst.key} amountValue={pricing.platformFee.tax.sgst.value} />
          )}
        </>
      )}
      <Divider sx={{ my: 1 }} />

      {/* Platform Subtotal */}
      {pricing?.platformFee?.total && (
        <AmountRow amountLabel={pricing.platformFee.total.key} amountValue={pricing.platformFee.total.value} />
      )}

      <Divider sx={{ my: 1 }} />


      {/* convenienceFee */}
      {pricing?.convenienceFee?.netFee?.value != 0 && (
        <AmountRow
          amountLabel={pricing.convenienceFee.netFee.key}
          amountValue={pricing.convenienceFee.netFee.value}
        />
      )}

      {/* Platform Fee Tax */}
      {pricing?.convenienceFee?.tax?.isIGST?.value ? (
        pricing?.convenienceFee?.tax?.igst && (
          <AmountRow amountLabel={pricing.convenienceFee.tax.igst.key} amountValue={pricing.convenienceFee.tax.igst.value} />
        )
      ) : (
        <>
          {pricing?.convenienceFee?.tax?.cgst && (
            <AmountRow amountLabel={pricing.convenienceFee.tax.cgst.key} amountValue={pricing.convenienceFee.tax.cgst.value} />
          )}
          {pricing?.convenienceFee?.tax?.sgst && (
            <AmountRow amountLabel={pricing.convenienceFee.tax.sgst.key} amountValue={pricing.convenienceFee.tax.sgst.value} />
          )}
        </>
      )}

      <Divider sx={{ my: 1 }} />

      {/* convenienceFee Subtotal */}
      {pricing?.convenienceFee?.total && (
        <AmountRow amountLabel={pricing.convenienceFee.total.key} amountValue={pricing.convenienceFee.total.value} />
      )}

      {pricing?.convenienceFee?.discount?.value != 0 && (
        <AmountRow
          amountLabel={`${pricing.convenienceFee.discount.key}${pricing.convenienceFee.discount?.config?.reason ? ` - ${pricing.convenienceFee.discount.config.reason}` : ''}`}
          amountValue={pricing.convenienceFee.discount.value}
        />
      )}

      <Divider sx={{ my: 1 }} />
      {/* Gateway Amount */}
      {(() => {
        const gwVal = Number(pricing?.gatewayCharges?.total?.value) || 0;
        return gwVal > 0 ? (
          <>
            <Box display="flex" justifyContent="space-between">
              <Typography variant="body2">Payment Gateway Charges:</Typography>
              <Typography variant="body2">₹ {gwVal}</Typography>
            </Box>
            <Divider sx={{ my: 1 }} />
          </>
        ) : null;
      })()}
      {/* Round Off */}
      {pricing?.roundOffValue && (
        <AmountRow amountLabel={pricing.roundOffValue.key} amountValue={pricing.roundOffValue.value} />
      )}



      <Divider sx={{ my: 1 }} />
      {/* Final Amount */}
      {pricing?.finalAmount?.value && (
        <Box display="flex" justifyContent="space-between" my={2}>
          <Typography variant="h6" fontWeight="bold">
            {pricing?.finalAmount?.key}
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            ₹ {pricing?.finalAmount?.value}
          </Typography>
        </Box>
      )}


      {/* Final Amount */}
      {pricing?.finalAmount2?.value && (

        <Box display="flex" justifyContent="space-between" my={2}>
          <Typography variant="h6" fontWeight="bold">
            {pricing?.finalAmount2?.key}
          </Typography>
          <Typography variant="h6" fontWeight="bold">
            ₹ {pricing?.finalAmount2?.value}
          </Typography>
        </Box>
      )}


      {/* Final Text (if any) */}
      {/* {pricing?.finalText && (
        <Typography variant="caption" color="text.secondary">
          {pricing.finalText}
        </Typography>
      )} */}

      <Divider sx={{ mt: 2 }} />
    </Box>
  );
};

export default PaymentSplitDetails;
